import React from 'react'
import { Tag, Popconfirm, Space, Divider, Button } from 'antd'
import { getUserNameFromType } from '../../../../config/const'

import { configureField } from '../../../../core/utils/list'

const confirmationMessage = 'Are you sure?'

export const basicColumns = (props) => {
  const { reset, loading, filters, resize, hidden } = props

  if (loading) return []

  return [
    {
      title: 'Username',
      dataIndex: 'username',
      ...configureField('u.username', filters, resize, hidden, true, false, false, 400),
      render: (name, record) => <>{name}</>
    },
    {
      title: 'Type',
      dataIndex: 'type',
      ...configureField('u.type', filters, resize, hidden, true, false, false, 400),
      render: (type) => <>{getUserNameFromType(type)}</>
    },
    {
      title: 'EMail',
      dataIndex: 'email',
      ...configureField('u.email', filters, resize, hidden, true, false, false, 400)
    },
    {
      title: 'Vendor',
      dataIndex: 'vendor',
      key: 'vendor',
      render: (vendor) => {
        if (vendor) {
          return <>{vendor.name}</>
        }
      }
    },
    {
      title: 'Status',
      dataIndex: 'active',
      width: 200,
      ...configureField('u.active', filters, resize, hidden, true, true, false, 200),
      render: (check) => (
        <>{check ? <Tag color='green'> ENABLED </Tag> : <Tag color='volcano'> DISABLED </Tag>}</>
      )
    },
    {
      title: 'Action',
      key: 'action',
      ...configureField('u.active', filters, resize, hidden, false, false, false, 200),
      render: (text, record) => {
        return (
          <Space size='small' split={<Divider type='vertical' />}>
            <Popconfirm
              title={confirmationMessage}
              onConfirm={() => reset(record.id)}
              okText='Yes'
              cancelText='No'
            >
              <Button size='small' type='link' disabled={props.loading}>
                Reset password
              </Button>
            </Popconfirm>
          </Space>
        )
      }
    }
  ]
}
